import { useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import useTrackTabChange from './useTrackTabChange';
import { storeTokenInLocalStorage } from 'utils/helperMethods';

// Function to renew the token using Auth0
const renewToken = (callback: Function, webAuth: auth0.WebAuth) => {
    webAuth.checkSession({}, (err, authResult) => {
        if (err) {
            console.error('Error renewing token', err);
            callback(false);
            return;
        }

        if (authResult && authResult.accessToken && authResult.idToken) {
            storeTokenInLocalStorage(authResult);
            callback(true);
        } else {
            callback(false);
        }
    });
};

type Props = {
    webAuth: auth0.WebAuth;
};

// Custom hook for token renewal
const useTokenRenewal = ({ webAuth }: Props) => {
    const isTabChanged = useTrackTabChange();
    useEffect(() => {
        const checkAndRenewTokens = () => {
            const accessToken = localStorage.getItem('accessToken');

            if (!accessToken) {
                return;
            }
            const decodedToken = jwtDecode(accessToken);
            const currentTime = Date.now() / 1000;
            // Renew token 5 minutes before expiry
            const shouldRenewToken = decodedToken?.exp ? decodedToken?.exp - currentTime < 300 : false;

            if (shouldRenewToken) {
                renewToken((success: boolean) => {
                    if (!success) {
                        console.error('Error renewing token');
                        return;
                    }
                }, webAuth);
            }
        };

        const renewalInterval = setInterval(checkAndRenewTokens, 60 * 1000); // Check every minute

        return () => clearInterval(renewalInterval); // Cleanup interval on component unmount
    }, [isTabChanged]);
};

export default useTokenRenewal;
